import React from 'react'
import { Table, Col, Button, Glyphicon } from 'react-bootstrap'
import { Scrollbars } from 'react-custom-scrollbars';
import { TextAreaBox } from 'fw/forms';
import { SponsorDocumentsGrid } from 'areas/shared/components';
import * as Formatting from 'fw/misc/Formatting';
import * as Modals from 'fw/globals/Modals';
import * as API from 'modules/app/API'
import DirectAPI from 'fw/system/API'

class SponsorCommentsGrid extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            newComment: '',
            comments: this.props.comments
        }
    }

    renderRow = (e, i) => {
        const row = (
            <tr key={i}>
                <td className='col-md-2 react-grid-Cell'>{e.addedBy}</td>
                <td className='react-grid-Cell'>
                    <span dangerouslySetInnerHTML={{ __html: e.content }} />
                </td>
                <td className='col-md-2 react-grid-Cell'> {Formatting.formatClientDateTime(e.addedDate)}</td>
                <td className='react-grid-Cell' align='center' style={{ cursor: 'pointer' }} onClick={() => this.handleDelete(e)}>
                    <Glyphicon glyph='remove' />
                </td>
            </tr>
        )
        return [row]
    }

    addComment = (comment) => {
        this.handleAdd(comment)
    }

    handleCommentChange = (value) => {
        this.setState({
            newComment: value
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            comments: nextProps.comments
        });
    }

    handleAdd = (paramComment) => {
        // Assign comment from param or from the control itself depending on the origin
        let comment = typeof paramComment === 'string' || paramComment instanceof String ? paramComment : this.state.newComment;

        if (!comment)
            return;

        let comments = this.state.comments;

        const rq = {
            sponsorId: this.props.sponsorId,
            content: comment
        }

        API.Sponsor.post('/sponsorSetup/addComment', rq, {
            success: (sr) => {
                comments.unshift({
                    commentId: sr.data.commentId,
                    content: sr.data.content,
                    addedDate: sr.data.addedAt,
                    addedBy: sr.data.addedBy
                });

                this.setState({
                    newComment: '',
                    comments: comments
                });

                if (this.props.onSave)
                    this.props.onSave(comments);
            }
        })
    }

    handleDelete = (comment) => {
        if (!comment) return

        let shortenedContent = comment.content.length > 20 ? comment.content.substr(0, 20) + '&hellip;' : comment.content

        Modals.remove({
            title: 'Removing comment',
            elementType: 'comment',
            name: shortenedContent,
            reason: true,
            onYes: (id, reason) => {
                const rq = {
                    commentId: comment.commentId,
                    entityId: this.props.entityId,
                    reason: reason
                }

                API.Sponsor.post('/sponsorSetup/deleteComment', rq, {
                    success: (sr) => {
                        let comments = this.state.comments;
                        comments = comments.filter(x => x.commentId !== comment.commentId);

                        this.setState({ comments: comments });

                        if (this.props.onSave)
                            this.props.onSave(comments);
                    }
                });
            }
        });
    }

    exportData = () => {
        const rq = {
            sponsorId: this.props.sponsorId
        }

        API.Sponsor.post('/sponsorSetup/exportComment', rq, {
            success: (sr) => {
                new DirectAPI().download(sr.data)
            }
        })
    }
    
    render() {
        const comments = this.state.comments

        return (
            <React.Fragment>
                <Col md={12}>
                    <h3>
                        {this.props.logSectionTitle} <small>{this.props.logSectionSubtitle}</small>
                    </h3>
                    <hr />
                </Col>
                <Col md={12}>
                    <Scrollbars style={{ height: 150, border: 'solid hsl(0,0%,80%) 1px' }} autoHide>
                        <Table>
                            <thead>
                                <tr>
                                    <th className='react-grid-HeaderCell'>Added By</th>
                                    <th className='react-grid-HeaderCell'>Comment</th>
                                    <th className='react-grid-HeaderCell'>Date/Time</th>
                                    <th width='8%' className='react-grid-HeaderCell' />
                                </tr>
                            </thead>
                            <tbody>
                                {comments.map((e, i) => {
                                    return this.renderRow(e, i)
                                })}
                            </tbody>
                        </Table>
                    </Scrollbars>
                    {this.props.enableExport && (
                        <Button onClick={this.exportData} className='btn btn-default pull-left' style={{ marginTop: 5 }}>
                            <Glyphicon glyph='glyphicon glyphicon-export' style={{ marginRight: 10 }} />
                            Export CSV
                        </Button>
                    )}
                </Col>
                <Col md={12}>
                    <h3>
                        {this.props.commentSectionTitle} <small>{this.props.commentSectionSubtitle}</small>
                    </h3>
                    <hr />
                </Col>
                <Col md={8}>
                    {!this.props.readonly &&
                        <div style={{ marginTop: "5px" }}>
                            <div>
                                <TextAreaBox
                                    value={this.state.newComment}
                                    maxLength={255}
                                    placeholder='Add comment...'
                                    onChange={this.handleCommentChange}
                                    onEnter={this.handleAdd}
                                />
                                <div style={{ marginTop: '5px' }}>
                                    <Button onClick={this.handleAdd} bsStyle='default'>
                                        Add Comment
                                    </Button>
                                </div>
                                <br />
                            </div>
                        </div>
                    }
                </Col>
                <Col md={4}>
                    <SponsorDocumentsGrid
                        documents={this.props.documents}
                        sponsorId={this.props.sponsorId}
                        entityId={this.props.entityId}
                        onUploadDocument={this.handleAdd}
                        readonly={this.props.readonly} />
                </Col>
            </React.Fragment>)
    }
}

export default SponsorCommentsGrid

// Default properties
SponsorCommentsGrid.defaultProps = {
    logSectionTitle: 'Reviewer Log – ',
    logSectionSubtitle: 'History of all actions related to this member',
    commentSectionTitle: 'Reviewer Comments – ',
    commentSectionSubtitle: 'Please make any Comments regarding this Member below'
}



// WEBPACK FOOTER //
// ./src/areas/shared/components/sponsorCommentsGrid/SponsorCommentsGrid.js